import { dashboard } from "../../../telemetry/TraceLogging";
import { wrapWidget } from "../../components/WidgetContainer/WidgetFrame/WidgetFrameDynamicFeed";
import { updateSize } from "../../webUXApi/widgetApi";
import { getWidgetOrchestrator } from "../orchestrator/orchestrator";
import { getWidgetRegistrarAsync } from "../registrar/registrar";
import { WidgetFrameAdapter } from "./WidgetFrameAdapter";
import { Measures } from "../../../telemetry/Measures";
import { getResources } from "../../getResources";
import { isFeatureEnabled } from "../../../app/externalApi/VelocityApi";
import * as Constants from "../../constants";
export class WidgetRendererApi {
    async renderWidget(location, widgetId, instanceId, size, isPromoted, boardView) {
        let widgetFrame;
        let isTombstoned = false;
        let isRiverInstance = false;
        const orch = await getWidgetOrchestrator();
        let widgetInstance = (await orch.getWidgetInstances()).find((i) => {
            return i.widgetId === widgetId;
        });
        if (isFeatureEnabled("Feature_BoardsLite") && (widgetId === Constants.CalendarWidgetId || widgetId === Constants.ToDoWidgetId) &&
            (boardView === Constants.StartBoardId)) {
            // Special hack for outlook widgets under boards lite.  disconnectedCallback was change to not destroy
            // outlook widgets and here we fetch the existing instances back.
            widgetInstance = (await orch.getRiverInstances()).find((i) => {
                return i.widgetId === widgetId;
            });
        }
        let registrar = await getWidgetRegistrarAsync();
        // If widget instance is available, it is a platform or Outlook widget => check if it should be tombstoned
        // If widget instance is not available and it is a Peregrine widget => widget needs to be tombstoned
        isTombstoned = (widgetInstance && await registrar.isTombstoned(widgetInstance.widgetRegistration))
            || (!widgetInstance && widgetId.startsWith("com.") && widgetId !== Constants.CalendarWidgetId && widgetId !== Constants.ToDoWidgetId);
        if (isTombstoned) {
            widgetFrame = this.handleTombstoneRender(widgetId, location, orch, widgetInstance, size, isPromoted, boardView);
        }
        else {
            // If widget is not tombstoned and WebXT calls us to render, it is a platform or Outlook widget.
            // If a widget instance is available, the widget is pinned.
            // If widget instance is not available, the widget needs to be rendered in the river.
            if (!widgetInstance) {
                // WebXT will send a widgetDefinitionId as widgetId to render in the river.
                isRiverInstance = true;
                let riverWidgetRegistration = await this.tryGetWidgetRegistrationFromWidgetId(widgetId);
                if (riverWidgetRegistration) {
                    widgetInstance = await orch.addWidgetInstanceForRiver(riverWidgetRegistration);
                }
            }
            if (widgetInstance) {
                widgetInstance.widgetRegistration.isTombstoned = false;
                widgetInstance.boardView = boardView;
                widgetFrame = this.createWidgetFrame(location, widgetInstance, size, isPromoted);
            }
            else {
                // If we still aren't able to get an instance, the registration does not exist.
                // This means that the wrong id was sent as Windows expects definitionId to render widgets in river.
                // If the widget is not known to the orchestrator, it does not exist and must be destroyed.
                let widgetModelApi = window.__com_microsoft_dsh_widgetModelApiFactory
                    .tryGetApi("model", 1, 1);
                widgetModelApi === null || widgetModelApi === void 0 ? void 0 : widgetModelApi.removeWidget(widgetId, instanceId ? instanceId : 0);
                widgetFrame = new Promise((resolve, reject) => {
                    reject(new Error("Widget or registration for " + widgetId + " doesn't exist"));
                });
            }
        }
        widgetFrame
            .then((frame) => {
            this.logRenderWidgetResult(widgetId, isRiverInstance, isTombstoned, frame === null, widgetInstance, instanceId, isPromoted);
        })
            .catch((error) => {
            this.logRenderWidgetResult(widgetId, isRiverInstance, isTombstoned, true, widgetInstance, instanceId, isPromoted, error);
        });
        return widgetFrame;
    }
    logRenderWidgetResult(widgetId, isRiverInstance, isTombstoned, isWidgetFrameNull, widgetInstance, instanceId, isPromoted, error) {
        var _a, _b;
        Measures.logEvent(dashboard, "RenderWidget", 16777216 /* productAndServicePerformance */, {
            appId: (_a = widgetInstance === null || widgetInstance === void 0 ? void 0 : widgetInstance.widgetRegistration) === null || _a === void 0 ? void 0 : _a.appId,
            backingAppPFN: widgetInstance === null || widgetInstance === void 0 ? void 0 : widgetInstance.widgetRegistration.backingAppPFN,
            boardView: widgetInstance === null || widgetInstance === void 0 ? void 0 : widgetInstance.boardView,
            error: error,
            instanceId: instanceId,
            isPromoted: !!isPromoted,
            isRiverInstance: isRiverInstance,
            isWidgetFrameNull: isWidgetFrameNull,
            isWidgetInstanceUndefined: widgetInstance === undefined,
            isTombstoned: isTombstoned,
            providerId: (_b = widgetInstance === null || widgetInstance === void 0 ? void 0 : widgetInstance.widgetRegistration) === null || _b === void 0 ? void 0 : _b.providerId,
            widgetDefinitionId: widgetInstance === null || widgetInstance === void 0 ? void 0 : widgetInstance.widgetDefinitionId,
            widgetId: widgetId,
            widgetRemoved: !widgetInstance && !isTombstoned && !isRiverInstance,
        });
    }
    async handleTombstoneRender(widgetId, location, orch, widgetInstance, size, isPromoted, boardView) {
        let widgetDefinitionId = widgetInstance ? widgetInstance.widgetDefinitionId : widgetId;
        // For peregrine widgets, find widget instance using widget definition id
        if (!widgetInstance) {
            widgetInstance = (await orch.getWidgetInstances()).find((widgetInstance) => widgetInstance.widgetDefinitionId == widgetDefinitionId);
        }
        if (widgetInstance) {
            // Must set this value because rendering finishes before registrations are fully load
            widgetInstance.widgetRegistration.isTombstoned = true;
            widgetInstance.boardView = boardView;
            return this.createWidgetFrame(location, widgetInstance, size, isPromoted);
        }
        return null;
    }
    async createWidgetFrame(location, widgetInstance, size, isPromoted) {
        if (size) {
            updateSize(widgetInstance, size, "onSizeChangeStart");
            updateSize(widgetInstance, size, "onSizeChangeEnd");
        }
        // Frame tag name must be unique to use @customElement
        const tagName = (widgetInstance.widgetId.replace(/\./g, "-") + "-" + widgetInstance.instanceId + "-frame").toLowerCase();
        const config = { elementName: tagName, widgetInstance: widgetInstance };
        wrapWidget(location, config);
        // Don't hand back an IWidgetFrame before the instance has been initialized
        await widgetInstance.widgetInitializationPromise();
        if (isPromoted !== undefined && !!isPromoted) {
            // Append "Sponsored" to the title of widget if it is paid for through ads
            const propertiesApi = widgetInstance.tryGetApi("properties", 1, 1);
            let widgetTitle = propertiesApi === null || propertiesApi === void 0 ? void 0 : propertiesApi.getProperty("title");
            propertiesApi === null || propertiesApi === void 0 ? void 0 : propertiesApi.setProperty("title", widgetTitle + " " + getResources().PromotedWidgetTitle_suffix);
        }
        return new WidgetFrameAdapter(widgetInstance);
    }
    // If the widgetDefinitionId matches a registration, return that registration or null
    async tryGetWidgetRegistrationFromWidgetId(widgetDefinitionId, isTombstoned) {
        const orch = await getWidgetOrchestrator();
        const registrations = (await orch.getWidgetRegistrations()).filter((widgetRegistration) => widgetRegistration.id === widgetDefinitionId && (typeof widgetRegistration.entryPoint.host !== "undefined" || isTombstoned));
        if (registrations.length === 1) {
            return registrations[0];
        }
        return null;
    }
}
